import { render, staticRenderFns } from "./picture-message.vue?vue&type=template&id=781a79ce&scoped=true&"
import script from "./picture-message.vue?vue&type=script&lang=js&"
export * from "./picture-message.vue?vue&type=script&lang=js&"
import style0 from "./picture-message.vue?vue&type=style&index=0&id=781a79ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a79ce",
  null
  
)

export default component.exports